import ReactGA from "react-ga4";

/**
 * One place for every analytics event on the house, room and booking pages.
 * Names follow Google Analytics 4's recommended events where one exists
 * (view_item_list, select_item, view_item, begin_checkout, add_to_wishlist),
 * so the standard GA4 reports work. The rest are custom.
 *
 * No personal data is ever sent: no names, emails or phone numbers.
 *
 * Share tracking stays in ./analytics.ts (trackShare): it also records to our backend.
 */

export type AnalyticsEvent =
  | "view_item_list"
  | "filter_rooms"
  | "select_dates"
  | "select_item"
  | "view_item"
  | "view_room_photos"
  | "view_full_room"
  | "begin_checkout"
  | "login_required"
  | "booking_request_submitted"
  | "add_to_wishlist";

type ParamValue = string | number | boolean | null | undefined | object;

export const CURRENCY = "USD";

export const track = (
  name: AnalyticsEvent,
  params: Record<string, ParamValue> = {}
) => {
  try {
    const cleaned: Record<string, ParamValue> = {};
    Object.keys(params).forEach((key) => {
      const value = params[key];
      if (value !== undefined && value !== null && value !== "") {
        cleaned[key] = value;
      }
    });
    ReactGA.event(name, cleaned);
  } catch (error) {
    // Analytics must never break the page.
  }
};

interface ItemRoom {
  id: number | string;
  name: string;
  price_per_month: string | number;
}

interface ItemProperty {
  slug: string;
  title: string;
}

/** A room in the shape GA4 expects for its "items" list. */
export const roomItem = (room: ItemRoom, property: ItemProperty) => ({
  item_id: String(room.id),
  item_name: room.name,
  item_category: property.title,
  item_variant: property.slug,
  price: Number(room.price_per_month) || 0,
  quantity: 1,
});
